export default function removeEmptyFields(object) {
    return Object.entries(object).reduce((acc, [field, value]) => {
        if (!value) return acc;

        acc[field] = value;

        return acc;
    }, {});
}
